




















































































































































































































import AppList from './AppList.vue';

// CODEMIRROR
import { VCodemirror } from 'v-codemirror'; // https://www.npmjs.com/package/v-codemirror
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css';
import 'codemirror/addon/hint/show-hint';
import 'codemirror/addon/hint/show-hint.css';
import 'codemirror/addon/hint/javascript-hint';
import 'codemirror/addon/hint/css-hint';
import 'codemirror/addon/display/autorefresh';
import 'codemirror/addon/edit/closebrackets';
import 'codemirror/theme/neat.css';
import { idGenerator } from '@/Utils';

export default {
	name: 'AppConfig',
	components: {
		AppList,
		'V-Codemirror': VCodemirror,
	},
	props: {
		visible: {
			type: Boolean,
			required: true,
		},
		app: {
			type: Object,
			required: true,
		},
		currentSelection: {
			type: Object,
			required: true,
		},
	},
	data() {
		const validateURL = (rule, value, callback) => {
			const currValue =
				this.input !== '' ? this.input : this.$refs.urlField[this.form.urls.indexOf(value)].currentValue || '';
			if (value === '___') {
				// https://gist.github.com/dperini/729294
				if (
					currValue.match(
						/^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i
					) === null &&
					currValue.match(/^http:\/\/\w+(\.\w+)*(:[0-9]+)?\/?(\/[.\w]*)*$/) === null
				)
					return callback(new Error(this.$t('appConfig.validation.urlValid')));
			} else if (value.indexOf('___') >= 0 && value.split('___')[1] === '') {
				if (currValue === '') return callback(new Error(this.$t('appConfig.validation.valueRequired')));
			} else if (value.indexOf('___') >= 0 && value.split('___')[1] !== '') {
				if (currValue === '') return callback(new Error(this.$t('appConfig.validation.valueRequired')));
			}
			callback();
		};
		return {
			input: '',
			active: 0,
			loading: false,
			codeJS: {
				mode: 'text/javascript',
				theme: 'neat',
				autoRefresh: true,
				lineWrapping: true,
				lineNumbers: true,
				indentWithTabs: true,
				autoCloseBrackets: true,
				tabSize: 4,
				extraKeys: { 'Ctrl-Space': 'autocomplete' },
			},
			codeCSS: {
				mode: 'text/css',
				theme: 'neat',
				autoRefresh: true,
				lineWrapping: true,
				lineNumbers: true,
				indentWithTabs: true,
				autoCloseBrackets: true,
				tabSize: 4,
				extraKeys: { 'Ctrl-Space': 'autocomplete' },
			},
			rules: {
				name: [{ required: true, message: this.$t('appConfig.validation.nameRequired'), trigger: 'blur' }],
				url: [{ required: true, type: 'url', message: this.$t('appConfig.validation.urlInvalid'), trigger: 'blur' }],
				urlType: [{ required: true, validator: validateURL, trigger: 'blur' }],
			},
			options: [
				{ value: 'auto', label: 'Auto Detect' },
				{ value: 'off', label: 'No Proxy' },
				{ value: 'http', label: 'HTTP' },
				{ value: 'https', label: 'HTTPS' },
				{ value: 'socks', label: 'Socks' },
				{ value: 'socks4', label: 'Socks4' },
				{ value: 'socks5', label: 'Socks5' },
			],
			linkHandlingOpts: [
				{ value: 'default', label: 'Default' },
				{ value: 'block', label: 'Block all pop-ups' },
				{ value: 'popup', label: 'Open all in pop-ups' },
				{ value: 'external', label: 'Open all in default browser' },
				{ value: 'temptab', label: 'Open all in tabs' },
			],
			form: {
				name: '',
				description: '',
				website: null,
				urls: [],
				url: '',
				icon: 'custom.png',

				tabTitle: true,
				enabled: true,
				notifications: true,
				sounds: true,
				blockads: false,
				hibernate: 15,
				startHibernated: false,
				mobile: false,
				spellcheck: 'default',

				stylishURL: '',
				jsCode: '',
				cssCode: '',

				webview: {
					allowpopups: 'default',
					useragent: '',
				},

				profile: 'inherit',

				proxy: {
					type: 'auto',
					host: '',
					port: 80,
					username: '',
					password: '',
				},
				logo: '',

				displayTabUnreadCounter: true,
				includeInGroupUnreadCounter: true,
			},
			path: '',
		};
	},
	computed: {
		workspaces(): Object {
			return this.$store.state.workspaces;
		},
		services(): object[] {
			return this.$store.state.allServices;
		},
		categories(): object[] {
			return this.$store.state.categories;
		},
		organizationPath(): string {
			return this.$store.getters.path;
		},
		isRootPath(): boolean {
			return (
				(this.form && this.form.path && this.form.path.indexOf('/apps') === -1) ||
				(this.app && this.app.path && this.app.path.indexOf('/apps') === -1)
			);
		},
		usersProfiles(): { key: string; name: string; system?: boolean }[] {
			let arr = [...this.$store.getters.getUserProfiles];
			!this.app.editRoleFromUser &&
				this.currentSelection &&
				this.currentSelection.profiles &&
				Object.keys(this.currentSelection.profiles).forEach(key =>
					arr.push({ key: key, name: this.currentSelection.profiles[key] })
				);
			this.isRootPath && (arr = arr.filter(el => el.key !== 'inherit'));
			return arr;
		},
	},
	watch: {
		visible(newValue, oldValue): void {
			if (newValue === oldValue) return;
			this.app.key && (this.form = { ...this.form, ...this.app });
			this.isRootPath && this.form.profile === 'inherit' && (this.form.profile = 'primary');
		},
	},
	methods: {
		showURLs(): boolean {
			const service = this.$store.state.allServices.find(el => el.id === this.form.serviceId);
			return (
				this.form.serviceId === 'custom' ||
				(this.form.serviceId !== 'custom' &&
					service &&
					service.urls.length === 1 &&
					service.urls[0].indexOf('___') !== -1)
			);
		},
		async validateForm(): Promise<boolean> {
			try {
				return await this.$refs.form.validate();
			} catch (error) {
				return false;
			}
		},
		onPickFile() {
			this.$refs.fileInput.click();
		},
		onFilePicked(e) {
			let files = e.target.files;
			if (files[0] !== undefined) {
				if (files[0].type !== 'image/png') {
					files = [];
					this.$message.error('App logo must be png format!');
					return;
				}
				var image = new Image();
				const fileReader = new FileReader();
				fileReader.addEventListener('load', () => {
					image.src = fileReader.result as string;
					image.addEventListener('load', () => {
						image.height !== 128 || image.width !== 128
							? this.$message.error('App logo must be 128px x 128px!')
							: (this.form.logo = fileReader.result);
					});
				});
				fileReader.readAsDataURL(files[0]);
			}
		},
		open(url) {
			window.open(url);
		},
		onSelectedService(service) {
			this.form.name = service.name;
			this.form.description = service.description;
			this.form.urls = service.urls;
			this.form.urlType = service.urls[0];
			this.form.website = service.website;
			service.profile && (this.form.profile = service.profile);
			this.form.icon = service.id + '.png';
			this.form.serviceId = service.id;
			if (service.serviceId === 'custom') this.form.url = '';

			this.active = 1;
			setTimeout(() => this.$refs.nameField.focus(), 200);
		},
		async onEditApp(): Promise<void> {
			const editedApp = {
				title: this.form.name,
				href: this.form.url,
				logo: this.form.logo,
				hibernate: this.form.hibernate,
				startHibernated: this.form.startHibernated,
				profile: this.form.profile,
				jsCode: this.form.jsCode,
				cssCode: this.form.cssCode,
				webview: this.form.webview,
				proxy: this.form.proxy,
				mobile: this.form.mobile,
			};
			const originalApp = this.$store.getters
				.getElement({
					roleUserId:
						this.app.role && this.currentSelection.role ? this.currentSelection.role : this.currentSelection.id,
					path: this.form.path,
				})
				.find(el => el.key === this.form.key);

			['jsCode', 'href', 'cssCode', 'logo', 'title', 'hibernate', 'startHibernated', 'mobile', 'profile'].forEach(
				key => originalApp[key] && originalApp[key] === editedApp[key] && delete editedApp[key]
			);
			let differentProxy = false;
			['host', 'password', 'port', 'type', 'username'].forEach(
				key => originalApp.proxy[key] !== editedApp.proxy[key] && (differentProxy = true)
			);
			!differentProxy && delete editedApp.proxy;

			originalApp.webview.useragent === editedApp.webview.useragent &&
				originalApp.webview.allowpopups === editedApp.webview.allowpopups &&
				delete editedApp.webview;
			if (Object.keys(editedApp).length === 0) return this.$parent.$parent.closeDrawer();

			// const valid = await this.validateForm();
			// if (!valid) return;
			this.loading = true;

			const data: { id: string; path: string | null; data: Object } = {
				id: this.form.key,
				path: this.form.path,
				data: editedApp,
			};

			try {
				await this.$firebase.functions().httpsCallable('editAppDesktop')(data);
				this.loading = false;

				this.$refs.drawer.closeDrawer();

				this.$message({
					type: 'success',
					message: this.$t('appConfig.appEdited'),
				});
			} catch (error) {
				this.loading = false;
				console.log(error);

				this.$message({
					type: 'error',
					message: this.$translateError(error),
				});
			}
		},
		async onNewApp(): Promise<void> {
			let url = '';
			if (this.form.serviceId === 'custom') {
				url = this.form.url;
			} else {
				// Generate final URL
				const urlField = this.$refs.urlField[this.form.urls.indexOf(this.form.urlType)];
				if (urlField.$slots.prepend || urlField.$slots.append) {
					urlField.$slots.prepend && (url += urlField.$slots.prepend[0].text);
					url += this.input;
					urlField.$slots.append && (url += urlField.$slots.append[0].text);
				} else {
					url += urlField.value;
				}
			}

			const newApp = {
				serviceId: this.form.serviceId,
				title: this.form.name,
				icon: this.form.serviceId + '.png',
				logo: this.form.logo,
				href: url,

				mobile: this.form.mobile,

				jsCode: this.form.jsCode,
				cssCode: this.form.cssCode,

				webview: {
					allowpopups: this.form.webview.allowpopups,
					useragent: this.form.webview.useragent,
				},

				profile: this.form.profile,

				hibernate: this.form.hibernate,
				startHibernated: this.form.startHibernated,

				proxy: {
					type: this.form.proxy.type,
					host: this.form.proxy.host,
					port: this.form.proxy.port,
					username: this.form.proxy.username,
					password: this.form.proxy.password,
				},
			};
			// const valid = await this.validateForm();
			// if (!valid) return;

			this.loading = true;

			const data: { path: string; app: Object; id: string } = {
				path: this.app.path,
				app: newApp,
				id: idGenerator(),
			};

			try {
				await this.$firebase.functions().httpsCallable('addApp')(data);
				this.loading = false;

				this.$refs.drawer.closeDrawer();

				this.$message({
					type: 'success',
					message: this.$t('appConfig.appCreated'),
				});
			} catch (error) {
				this.loading = false;
				console.log(error);

				this.$message({
					type: 'error',
					message: this.$translateError(error),
				});
			}
		},
		handleDrawerClose(): void {
			this.form = this.$options.data.call(this).form; // Set the default data in form
			this.$refs.form && this.$refs.form.resetFields();
			this.active = 0;
			this.$emit('handleClose');
		},
	},
};
